export const Check1 = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2558 4.41C17.4121 4.56628 17.4998 4.7782 17.4998 4.99917C17.4998 5.22014 17.4121 5.43206 17.2558 5.58834L8.08917 14.755C7.93289 14.9112 7.72097 14.999 7.5 14.999C7.27903 14.999 7.06711 14.9112 6.91083 14.755L2.74417 10.5883C2.66458 10.5115 2.60109 10.4195 2.55742 10.3178C2.51374 10.2162 2.49075 10.1068 2.48979 9.99617C2.48883 9.88552 2.50992 9.77579 2.55182 9.67338C2.59372 9.57096 2.6556 9.47792 2.73384 9.39967C2.81208 9.32143 2.90513 9.25955 3.00754 9.21765C3.10995 9.17575 3.21969 9.15467 3.33034 9.15563C3.44099 9.15659 3.55034 9.17958 3.65201 9.22325C3.75368 9.26693 3.84563 9.33041 3.9225 9.41L7.5 12.9875L16.0775 4.41C16.2338 4.25378 16.4457 4.16602 16.6667 4.16602C16.8876 4.16602 17.0996 4.25378 17.2558 4.41Z"
        fill="currentColor"
      />
    </svg>
  );
};
